export const fightHistoryStageTranslations = {
    en: {
        addFightHistory: 'Add Fight History',
        opponentName: 'Opponent Name',
        enterOpponentName: 'Enter opponent name',
        opponentNameRequired: 'Opponent name is required',
        date: 'Date',
        dateRequired: 'Date is required',
        location: 'Location',
        enterLocation: 'Enter location',
        locationRequired: 'Location is required',
        result: 'Result',
        selectLocation: "Select location",
        Location: "Location",
        selectResult: 'Select Result',
        resultRequired: 'Result is required',
        round: 'Round',
        enterRoundNumber: 'Enter round number',
        roundNegative: 'Round cannot be negative',
        roundRequiredOrInvalid: "Round is required and must be at least 1",
        typeOfEnding: 'Type of Ending',
        selectTypeOfEnding: 'Select type of ending',
        typeOfEndingRequired: 'Type of ending is required',
        win: 'Win',
        loss: 'Loss',
        ko: 'KO',
        tko: 'TKO',
        submission: 'Submission',
        decision: 'Decision',
        draw: 'Draw',
        dq: 'DQ',
        noContest: 'No Contest',
        organizationName: 'Organization Name',
        enterOrganizationName: 'Enter organization name',
        optional: 'Optional',
        cancel: 'Cancel',
        submit: 'Add Fight',
        noFightHistory: 'No Fight History',
        addFirstFight: 'Add your first fight to get started',
        fillFightDetails: 'Fill in the fight details',
        removeFight: 'Remove Fight',
        fightHistory: 'Fight History',
        manageFightRecords: 'Manage your fight records',
        fight_removed_successfully: 'Fight removed successfully',
        selectPreferredRuleSet: 'Select Level',
        preferredRuleSetRequired: 'Level is required',

        // Newly added
        organization: 'Organization',
        competitionLevel: 'Competition Level',
        method: 'Method'
    },
    de: {
        addFightHistory: 'Kampfverlauf hinzufügen',
        opponentName: 'Gegnername',
        enterOpponentName: 'Gegnername eingeben',
        opponentNameRequired: 'Gegnername ist erforderlich',
        date: 'Datum',
        dateRequired: 'Datum ist erforderlich',
        location: 'Ort',
        enterLocation: 'Ort eingeben',
        locationRequired: 'Ort ist erforderlich',
        result: 'Ergebnis',
        selectResult: 'Ergebnis auswählen',
        resultRequired: 'Ergebnis ist erforderlich',
        selectLocation: 'Standort auswählen',
        Location: 'Standort',
        round: 'Runde',
        enterRoundNumber: 'Rundennummer eingeben',
        roundNegative: 'Runde darf nicht negativ sein',
        roundRequiredOrInvalid: "Runde ist erforderlich und muss mindestens 1 sein",
        typeOfEnding: 'Art des Endes',
        selectTypeOfEnding: 'Art des Endes auswählen',
        typeOfEndingRequired: 'Art des Endes ist erforderlich',
        win: 'Sieg',
        loss: 'Niederlage',
        ko: 'KO',
        tko: 'TKO',
        submission: 'Unterwerfung',
        decision: 'Entscheidung',
        draw: 'Unentschieden',
        dq: 'Disqualifikation',
        noContest: 'Kein Wettkampf',
        organizationName: 'Organisationsname',
        enterOrganizationName: 'Organisationsname eingeben',
        optional: 'Optional',
        cancel: 'Abbrechen',
        submit: 'Kampf hinzufügen',
        noFightHistory: 'Kein Kampfverlauf',
        addFirstFight: 'Fügen Sie Ihren ersten Kampf hinzu, um zu beginnen',
        fillFightDetails: 'Füllen Sie die Kampfdetails aus',
        removeFight: 'Kampf entfernen',
        fightHistory: 'Kampfverlauf',
        manageFightRecords: 'Verwalten Sie Ihre Kampfaufzeichnungen',
        fight_removed_successfully: 'Kampf erfolgreich entfernt',
        selectPreferredRuleSet: 'Level auswählen',
        preferredRuleSetRequired: 'Level ist erforderlich',

        // Newly added
        organization: 'Organisation',
        competitionLevel: 'Wettkampfniveau',
        method: 'Methode'
    },
    hr: {
        addFightHistory: 'Dodaj povijest borbi',
        opponentName: 'Ime protivnika',
        enterOpponentName: 'Unesite ime protivnika',
        opponentNameRequired: 'Ime protivnika je obavezno',
        date: 'Datum',
        dateRequired: 'Datum je obavezan',
        location: 'Mjesto',
        selectLocation: 'Odaberite lokaciju',
        enterLocation: 'Unesite mjesto',
        locationRequired: 'Mjesto je obavezno',
        Location: 'Lokacija',
        result: 'Rezultat',
        selectResult: 'Odaberite rezultat',
        resultRequired: 'Rezultat je obavezan',
        round: 'Runda',
        enterRoundNumber: 'Unesite broj runde',
        roundNegative: 'Runda ne može biti negativna',
        roundRequiredOrInvalid: 'Runda je obavezna i mora biti najmanje 1',
        typeOfEnding: 'Vrsta završetka',
        selectTypeOfEnding: 'Odaberite vrstu završetka',
        typeOfEndingRequired: 'Vrsta završetka je obavezna',
        win: 'Pobjeda',
        loss: 'Poraz',
        ko: 'KO',
        tko: 'TKO',
        submission: 'Predaja',
        decision: 'Odluka',
        draw: 'Neriješeno',
        dq: 'Diskvalifikacija',
        noContest: 'Bez odluke',
        organizationName: 'Naziv organizacije',
        enterOrganizationName: 'Unesite naziv organizacije',
        optional: 'Opcionalno',
        cancel: 'Otkaži',
        submit: 'Dodaj borbu',
        noFightHistory: 'Nema povijesti borbi',
        addFirstFight: 'Dodajte svoju prvu borbu da započnete',
        fillFightDetails: 'Ispunite detalje borbe',
        removeFight: 'Ukloni borbu',
        fightHistory: 'Povijest borbi',
        manageFightRecords: 'Upravljajte zapisima o borbama',
        fight_removed_successfully: 'Borba je uspješno uklonjena',
        selectPreferredRuleSet: 'Odaberite razinu',
        preferredRuleSetRequired: 'Razina je obavezna',

        // Newly added
        organization: 'Organizacija',
        competitionLevel: 'Razina natjecanja',
        method: 'Metoda'
    }
};
